import { API_V1 } from '../constants/api';
import { defaultClient, fesClient, authClient } from './client';

export const findInfinityTenant = body => fesClient.post('/embed/infinity/tenants', body);
export const getCachedDemoPage = ({ tenantId }) => fesClient.get(`/embed/infinity/demo/tenant/${tenantId}`);
export const cacheDemoPage = ({ tenantId, userId }) =>
  fesClient.post(`/embed/infinity/demo/tenant/${tenantId}/${userId}`);

export const authenticateInfinityToken = body => authClient.post(`${API_V1}/infinity_login`, body);
export const getMe = () => defaultClient.get(`${API_V1}/me`);
